import axios from 'axios';
import { logout } from './auth'; // Import the logout function

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AXIOS_BASE_URL, // Base URL for your API
});

// Request Interceptor: Attach the token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken'); // Retrieve token from localStorage
    if (token) {
      config.headers.Authorization = `Token ${token}`; // Set the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle unauthorized errors (401)
axiosInstance.interceptors.response.use(
  (response) => {
    // If the response is successful, just return the response
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // If the server returns 401 Unauthorized, log the user out
      console.error('Unauthorized: Logging out the user.');
      logout(); // Call the logout function
    }
    return Promise.reject(error); // Pass the error to the caller
  }
);

// Create another Axios instance for the Amarlab API with x-api-key
const axiosAmarlabInstance = axios.create({
  baseURL: process.env.REACT_APP_AMARLAB_API, // Base URL for the Amarlab API
});

// Request Interceptor: Attach the x-api-key to every request
axiosAmarlabInstance.interceptors.request.use(
  (config) => {
    const apiKey = process.env.REACT_APP_AMARLAB_API_KEY; // Retrieve the API key from environment variables
    if (apiKey) {
      config.headers['X-API-KEY'] = apiKey; // Set the x-api-key header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export { axiosInstance, axiosAmarlabInstance };
